import { parseMoney, formatMoney, priceFromLineAmount, lineAmountFromPrice } from "@ohc/shared";

export function priceForAmount(amount: string, quantity: string): string {
  try { return priceFromLineAmount(parseMoney(amount), Number(quantity)); } catch { return ""; }
}

export function amountForPrice(price: string, quantity: string): string {
  try { return formatMoney(lineAmountFromPrice(price, Number(quantity))); } catch { return ""; }
}
